
<div @dragover = "onDragover">
    <v-menu
        v-model                 = "menu"
        :close-on-content-click = "false"
        content-class           = "document-menu white"
        z-index                 ="100"
        offset-y
    >
        <template v-slot:activator="{ on, attrs }" >
            <a
                v-bind = "attrs"
                v-on   = "on"
                class  = "step-icon"
            >
                <v-icon>mdi-paperclip</v-icon>
                <span class = "mr-1">{{ documents ? documents.length : '0' }}</span>
                <i
                    class  = "ml-0 pr-2 fas primary--text"
                    :class = "menu?'fa-caret-up ' :'fa-caret-down '"
                />
            </a>
        </template>

        <c-dms-documents
            class         = "mt-3 ml-5 mr-3"
            :category     = "category"
            :documents    = "filtered"
            :step-data-id = "stepDataId"
            :step-name    = "stepName"
            @context      = "onContext"
            @search       = "onSearch"
        />
    </v-menu>
</div>
